import { SidebarMenu } from "./components";
import { Box } from "@mui/material";
import { useStyles } from "./style";
import { AppRoutes } from "./routes";

function App() {
  const classes = useStyles();

  return (
    <Box className={classes.appContainer}>
      <SidebarMenu />

      <Box className={classes.pagesContainer}>
        <AppRoutes />
      </Box>
    </Box>
  );
}

export default App;
